import { useEffect, useRef, useState } from "react";

import { ObservabilityPipelineResourcesOverview } from "Api/observability/pipeline/types";
import { Poller } from "src/organization/pages/project/environment/metrics/utils/polling/poller";
import { MetricsPollType } from "src/organization/pages/project/environment/metrics/utils/polling/type";

type Props = Omit<
  MetricsPollType<ObservabilityPipelineResourcesOverview>,
  "timeframe"
>;

const usePoll = ({ onChange, onLoadingChange }: Props) => {
  const [data, setData] = useState<ObservabilityPipelineResourcesOverview>();

  const poller = useRef<Poller>(
    new Poller({
      onChange: d => {
        onChange(d);
        setData(d);
      },
      onError: () => onChange(),
      onLoadingChange
    })
  ).current;

  useEffect(() => {
    return () => poller.stopPolling();
  }, [poller]);

  return { data, poller };
};

export default usePoll;
